import { useState } from 'react'
import styled from 'styled-components'
import { OrderSheetCoupon } from '@shopby/shop-sdk'
import { useOrderContext } from '../provider/OrderProvider'
import OrderCartCouponModal from './OrderCartCouponModal'
import { plusComma, formatCouponDate } from '../../js/script'

const OrderCartCouponSection = ({
  cartCoupons,
  onApplyCartCoupon,
}: {
  cartCoupons: OrderSheetCoupon[]
  onApplyCartCoupon: (coupon: OrderSheetCoupon | null) => void
}) => {
  const { cartCoupon } = useOrderContext()
  const [isModal, setIsModal] = useState(false)

  if (cartCoupons.length === 0) {
    return (
      <CartCouponWrap>
        <Title>장바구니 쿠폰</Title>
        <ContentRow>
          <CouponInfo>
            <span className='no-coupon'>장바구니 쿠폰을 적용할 수 없는 상품이 존재합니다.</span>
          </CouponInfo>
        </ContentRow>
      </CartCouponWrap>
    )
  }

  const selectedCartCouponTitle = () => {
    if (!cartCoupon) return null
    // NOTE: 아래 장바구니 쿠폰 이슈로 displayCouponName은 현재 사용하지 않으나 정상 작동시 사용 부탁드립니다.
    // return `${cartCoupon.displayCouponName} / ${plusComma(cartCoupon.couponDiscountAmt)}원 할인`
    // return `${cartCoupon.couponName} - ${
    //   cartCoupon.fixedAmountDiscount
    //     ? `${plusComma(cartCoupon.couponDiscountAmt)}원 할인`
    //     : `${cartCoupon.discountRate}%(최대 ${plusComma(cartCoupon.maxDiscountAmt)}원 할인)`
    // } / ${formatCouponDate(cartCoupon.useEndYmdt)} 까지`
    return `${
      cartCoupon.fixedAmountDiscount
        ? `${plusComma(cartCoupon.couponDiscountAmt)}원 할인`
        : `${cartCoupon.discountRate}%(최대 ${plusComma(cartCoupon.maxDiscountAmt)}원 할인)`
    } - ${formatCouponDate(cartCoupon.useEndYmdt)} 까지`
    // return (
    //   `${
    //     cartCoupon.fixedAmountDiscount
    //       ? `${plusComma(cartCoupon.couponDiscountAmt)}원 할인`
    //       : `${cartCoupon.discountRate}% 할인`
    //   } - ${formatCouponDate(cartCoupon.useEndYmdt)} 까지` +
    //   `${cartCoupon.fixedAmountDiscount ? '' : ` (최대 ${plusComma(cartCoupon.maxDiscountAmt)}원 할인)`}`
    // )
  }

  return (
    <CartCouponWrap>
      <Title>장바구니 쿠폰</Title>
      <ContentRow>
        <CouponInfo>
          {cartCoupon ? (
            <>
              <RemoveBtn type='button' onClick={() => onApplyCartCoupon(null)} aria-label='쿠폰 해제'>
                ×
              </RemoveBtn>
              {/* NOTE: 아래 장바구니 쿠폰 이슈로 displayCouponName은 현재 사용하지 않으나 정상 작동시 사용 부탁드립니다. */}
              {/* <strong>{cartCoupon.displayCouponName}</strong> */}
              {/* <span className='divider'>/</span> */}
              {/* <span className='discount'>{Number(cartCoupon.couponDiscountAmt).toLocaleString()}원 할인</span> */}
              <strong>{selectedCartCouponTitle()}</strong>
            </>
          ) : (
            <span className='no-coupon'>장바구니 쿠폰이 적용되지 않았습니다.</span>
          )}
        </CouponInfo>
        <SelectBtn type='button' onClick={() => setIsModal(true)}>
          쿠폰 선택
        </SelectBtn>
      </ContentRow>
      {isModal && (
        <OrderCartCouponModal
          setIsModal={setIsModal}
          cartCoupons={cartCoupons}
          selectedCoupon={cartCoupon}
          onApplyCoupon={(coupon) => {
            onApplyCartCoupon(coupon)
            setIsModal(false)
          }}
        />
      )}
    </CartCouponWrap>
  )
}

export default OrderCartCouponSection

const CartCouponWrap = styled.div`
  margin: 32px 0px;
  @media (max-width: 600px) {
    padding: 24px 20px;
  }
`
const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
`
const ContentRow = styled.div`
  background: #f5faff;
  border-radius: 8px;
  padding: 18px 20px;
  margin: 20px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 600px) {
    padding: 14px 10px;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`
const CouponInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap; // 한 줄로만!
  min-width: 0;
  font-size: 15px;
  color: #0d47a1;
  font-weight: 500;

  .divider {
    color: #b0bec5;
    margin: 0 4px;
    font-weight: 400;
  }
  .discount {
    color: #1976d2;
    font-weight: 700;
    margin-left: 2px;
  }
  .no-coupon {
    color: #607d8b;
    font-weight: 500;
  }
`

const SelectBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1; // 한 줄로 맞춤
  padding: 8px 12px;
  z-index: 0;
  border: none;
  border-radius: 5px;
  background-color: var(--colBlack);
  color: var(--colWhite);
  white-space: nowrap; // 한 줄로만 출력
  flex-shrink: 0; // 줄어들지 않게
`
const RemoveBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #555c60;
  font-size: 18px;
  font-weight: 700;
  margin-left: 4px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  vertical-align: middle;
  transition: color 0.15s;
  &:hover {
    color: #d32f2f;
    background: #fbe9e7;
    border-radius: 50%;
  }
`
